export default __webpack_public_path__ + "static/media/first-american.db6a9633.svg";